import React from 'react';
import PropTypes from 'prop-types';
import { Header } from 'semantic-ui-react';
import { VariantProvider, MenuProvider, CartProvider } from './FoodMenu.context';
import { MenuNavigation } from './components';
import { computeVariants } from './components/variants';
import './FoodMenu.css';

export default class FoodMenu extends React.Component {
  render() {
    const {
      navDisplayVariant,
      categoryDisplayVariant,
      itemDisplayVariant,
      menu,
      header,
      centerHeader,
      centerNavigation,
      disableModifiers,
      disableSchedules,
      cart,
      precision
    } = this.props;

    const variantContext = {
      navDisplay: navDisplayVariant,
      categoryDisplay: categoryDisplayVariant,
      itemDisplay: itemDisplayVariant,
    };

    const headerStyle = centerHeader ? { textAlign: 'center' } : {};

    return (
      <React.Fragment>
        <VariantProvider value={computeVariants(variantContext)}>
          <MenuProvider value={{ ...menu, precision, disableModifiers, disableSchedules }}>
            <CartProvider value={cart}>
              {header && (
                <Header as="h1" className="fcfm-main-header" style={headerStyle}>
                  {header}
                </Header>
              )}
              <MenuNavigation center={centerNavigation} />
            </CartProvider>
          </MenuProvider>
        </VariantProvider>
      </React.Fragment>
    );
  }
}

FoodMenu.propTypes = {
  navDisplayVariant: PropTypes.oneOf(['BasicTabs', 'TabsCategorySidebar']),
  categoryDisplayVariant: PropTypes.oneOf([
    'VerticalList',
    'Column',
    'VerticalCardRow',
    'HorizontalCardRow',
  ]),
  itemDisplayVariant: PropTypes.oneOf([
    'Basic',
    'BasicCondensed',
    'HorizontalCard',
    'VerticalCard',
  ]),
  menu: PropTypes.shape({
    schedules: PropTypes.array,
    categories: PropTypes.array,
    items: PropTypes.array,
    modifierSets: PropTypes.array,
    modifiers: PropTypes.array,
  }).isRequired,
  header: PropTypes.string,
  centerHeader: PropTypes.bool,
  centerNavigation: PropTypes.bool,
  disableModifiers: PropTypes.bool,
  disableSchedules: PropTypes.bool,
  cart: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.shape({
      items: PropTypes.array,
      addItem: PropTypes.func,
      removeItem: PropTypes.func,
      updateItem: PropTypes.func,
      containsItem: PropTypes.func,
      clearCart: PropTypes.func,
      getItemIndex: PropTypes.func,
    }),
  ]),
  precision: PropTypes.oneOf([0, 1, 2])
};

FoodMenu.defaultProps = {
  navDisplayVariant: 'BasicTabs',
  categoryDisplayVariant: 'VerticalList',
  itemDisplayVariant: 'Basic',
  header: 'Menu',
  centerHeader: false,
  centerNavigation: false,
  disableModifiers: false,
  disableSchedules: false,
  cart: false,
  precision: 2
};
